import { RouteRecordRaw } from "vue-router";
import { HOME_URL } from "@/config";

export const staticLayoutRouter: any = [
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    meta: {
      title: "首页",
      icon: "House",
      isAffix: true,
      isKeepAlive: true
    }
  },
  {
    path: "/productPrice",
    name: "productPrice",
    component: () => import("@/views/productPrice/index.vue"),
    meta: {
      title: "产品价格公示",
      icon: "Reading"
    }
  },

  {
    path: "/product",
    name: "product",
    redirect: "/product/equip",
    meta: {
      title: "产品管理",
      icon: "Coin",
      isAffix: true,
      isKeepAlive: true
    },
    children: [
      {
        path: "/product/equip",
        name: "equip",
        component: () => import("@/views/equip/index.vue"),
        children: [],
        meta: {
          // isHide: true,
          title: "我的设备"
        }
      },
      {
        path: "/product/line",
        name: "line",
        component: () => import("@/views/line/index.vue"),
        children: [],
        meta: {
          // isHide: true,
          title: "我的线路"
        }
      }
    ]
  },
  {
    path: "/orderManagement",
    name: "orderManagement",
    redirect: "/orderManagement/order",
    meta: {
      title: "订单管理",
      icon: "ShoppingCart"
    },
    children: [
      {
        path: "/orderManagement/order",
        name: "order",
        component: () => import("@/views/order/index.vue"),
        children: [],
        meta: {
          title: "我的订单"
        }
      }
    ]
  },

  {
    path: "/userInfo",
    name: "userInfo",
    component: () => import("@/views/user/index.vue"),
    meta: {
      isHide: true,
      title: "个人中心",
      icon: "HomeFilled"
    }
  },
  {
    path: "/certification",
    name: "certification",
    component: () => import("@/views/certification/index.vue"),
    meta: {
      isHide: true,
      title: "实名认证",
      icon: "HomeFilled"
    }
  },
  {
    path: "/account",
    name: "account",
    component: () => import("@/views/account/index.vue"),
    meta: {
      title: "我的账户",
      icon: "Wallet"
    }
  },
  {
    path: "/capital",
    name: "capital",
    component: () => import("@/views/capital/index.vue"),
    children: [],
    meta: {
      title: "资金明细",
      icon: "Money"
    }
  },
  {
    path: "/recharge",
    name: "recharge",
    component: () => import("@/views/recharge/index.vue"),
    meta: {
      isHide: true,
      title: "充值",
      icon: "HomeFilled"
    }
  },
  {
    path: "/bill",
    name: "bill",
    component: () => import("@/views/bill/index.vue"),
    children: [],
    meta: {
      title: "账单管理",
      icon: "ToiletPaper"
    }
  },

  {
    path: "/invoice",
    name: "invoice",
    component: () => import("@/views/invoice/index.vue"),
    children: [],
    meta: {
      title: "发票管理",
      icon: "Tickets"
    }
  },

  {
    path: "/messageManger",
    name: "messageManger",
    component: () => import("@/views/messageManger/index.vue"),
    children: [],
    meta: {
      title: "站内信",
      icon: "ChatLineSquare"
    }
  },
  {
    path: "/coupon",
    name: "coupon",
    component: () => import("@/views/coupon/index.vue"),
    children: [],
    meta: {
      title: "优惠券管理",

      icon: "Postcard"
    }
  },

  {
    path: "/certification/success",
    name: "certificationSuccess",
    component: () => import("@/views/certification/success.vue"),
    children: [],
    meta: {
      isHide: true,
      title: "实名状态",
      icon: "HomeFilled"
    }
  },
  {
    path: "/certification/fail",
    name: "certificationfail",
    component: () => import("@/views/certification/fail.vue"),
    children: [],
    meta: {
      isHide: true,
      title: "实名状态",
      icon: "HomeFilled"
    }
  },
  {
    path: "/certification/pending",
    name: "certificationpending",
    component: () => import("@/views/certification/pending.vue"),
    children: [],
    meta: {
      isHide: true,
      title: "实名状态",
      icon: "HomeFilled"
    }
  },
  {
    path: "/paySuccess",
    name: "paySuccess",
    component: () => import("@/views/recharge/success.vue"),
    children: [],
    meta: {
      isHide: true,
      title: "充值成功",
      icon: "HomeFilled"
    }
  },
  {
    path: "/linePaySuccess",
    name: "linePaySuccess",
    component: () => import("@/components/ErcodePay/linePaySuccess.vue"),
    children: [],
    meta: {
      isHide: true,
      title: "充值成功",
      icon: "HomeFilled"
    }
  },
  {
    path: "/equipPaySuccess",
    name: "equipPaySuccess",
    component: () => import("@/components/ErcodePay/equipPaySuccess.vue"),
    children: [],
    meta: {
      isHide: true,
      title: "充值成功",
      icon: "HomeFilled"
    }
  },

  {
    path: "/allpaySuccess",
    name: "allpaySuccess",
    component: () => import("@/components/ErcodePay/allpaySuccess.vue"),
    children: [],
    meta: {
      isHide: true,
      title: "充值成功",
      icon: "HomeFilled"
    }
  },
  {
    path: "/waitPay/:id",
    name: "waitPay",
    component: () => import("@/views/waitPay/index.vue"),
    children: [],
    meta: {
      isHide: true,
      title: "待支付订单"
    }
  },
  {
    path: "/purchaseLine",
    name: "purchaseLine",
    component: () => import("@/views/purchaseLine/index.vue"),
    children: [],
    meta: {
      isHide: true,
      title: "购买线路",
      icon: "HomeFilled"
    }
  },
  {
    path: "/applyEquip",
    name: "applyEquip",
    component: () => import("@/views/equip/applyEquip.vue"),
    children: [],
    meta: {
      isHide: true,
      title: "申请设备",
      icon: "HomeFilled"
    }
  }
];
export const staticRouter: RouteRecordRaw[] = [
  {
    path: "/",
    redirect: "/layout"
  },
  {
    path: "/layout",
    name: "layout",
    component: () => import("@/layouts/indexAsync.vue"),
    redirect: HOME_URL,
    children: [...staticLayoutRouter]
  }
];

/**
 * errorRouter (错误页面路由)
 */
export const errorRouter = [
  {
    path: "/redirect",
    name: "redirect",
    component: () => import("@/views/redirect/index.vue"),
    meta: {
      title: "重定向"
    }
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@/components/ErrorMessage/403.vue"),
    meta: {
      title: "403页面"
    }
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/components/ErrorMessage/404.vue"),
    meta: {
      title: "404页面"
    }
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/components/ErrorMessage/500.vue"),
    meta: {
      title: "500页面"
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/login.vue"),
    meta: {
      title: "登录"
    }
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/login/register.vue"),
    meta: {
      title: "注册"
    }
  },

  {
    path: "/pwdReset",
    name: "pwdReset",
    component: () => import("@/views/login/pwdReset.vue"),
    meta: {
      title: "忘记密码"
    }
  },
  // Resolve refresh page, route warnings
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/components/ErrorMessage/404.vue")
  }
];
